import { useReactiveVar } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import { globalMode } from 'utility/cache/ui';
import { AccountingEntry } from './accountingEntry/list';
import { TransactionSigning } from './transactionSigning/list';
import { SortOrder } from './transactionSigning/view/FormView/AttachDocumentsForm/types';
import { useColumns } from './transactionSigning/list/columns.data';
import { ColumnData } from 'common/components/Modules/TransactionEdit/Accounting/columns.data';

export const Signing: React.FC<{
  filterSupplierId?: string;
  setTransactionId?: React.Dispatch<React.SetStateAction<string | undefined>>;
  setinvoiceListVisible?: React.Dispatch<React.SetStateAction<boolean>>;
  setIsAccountingEntry?: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({
  filterSupplierId,
  setTransactionId,
  setinvoiceListVisible,
  setIsAccountingEntry,
}) => {
    const globalState = useReactiveVar(globalMode);
    const { columns } = useColumns();
    const [gridColumns, setGridColumns] = useState<ColumnData[]>(columns);
    const [sortOrderParam, setSortOrderParam] = useState<SortOrder>();
    const [isSigningSearch, setSigningSearch] = React.useState(true);
    const [isHistorySearch, setIsHistorySearch] = React.useState<boolean>(false);
    const [isSearchAllData, setIsSearchAllData] = useState(true);

    useEffect(() => {
      if (!isSigningSearch && globalState) {
        setSigningSearch(true);
        setIsHistorySearch(false);
      }
    }, [globalState, isSigningSearch]);
    return (
      <>
        {isSigningSearch ? (
          <TransactionSigning
            setSigningSearch={setSigningSearch}
            setIsHistorySearch={setIsHistorySearch}
            isHistorySearch={isHistorySearch}
            isSigningSearch={isSigningSearch}
            isSearchAllData={isSearchAllData}
            onDefaultDataViewChange={setIsSearchAllData}
            gridColumns={gridColumns}
            setGridColumns={setGridColumns}
            sortOrderParam={sortOrderParam}
            setSortOrderParam={setSortOrderParam}
            filterSupplierId={filterSupplierId}
            setTransactionId={setTransactionId}
            setinvoiceListVisible={setinvoiceListVisible}
          />
        ) : (
          <AccountingEntry
            setIsHistorySearch={setIsHistorySearch}
            setSigningSearch={setSigningSearch}
            isHistorySearch={isHistorySearch}
            isSigningSearch={isSigningSearch}
            isSearchAllData={isSearchAllData}
            onDefaultDataViewChange={setIsSearchAllData}
            gridColumns={gridColumns}
            setGridColumns={setGridColumns}
            sortOrderParam={sortOrderParam}
            setSortOrderParam={setSortOrderParam}
            filterSupplierId={filterSupplierId}
            setTransactionId={setTransactionId}
            setinvoiceListVisible={setinvoiceListVisible}
            setIsAccountingEntry={setIsAccountingEntry}
          />
        )}
      </>
    );
  };
